var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{on:{"click":_vm.removeStickerLayout}},[_c('w-button',{attrs:{"icon":_vm.iconStickerRemoved,"size":"small","color":"text"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }